"use client";

import { c as _c } from "react/compiler-runtime";
import { HeroHeader } from "./hero";
import { LatestDropSection } from "./now-minting";
import { NextMintLeadingSection } from "@/components/home/next-mint-leading/NextMintLeadingSection";
import { BoostedSection } from "@/components/home/boosted/BoostedSection";
import { ExploreWavesSection } from "@/components/home/explore-waves/ExploreWavesSection";
import HomePageTextSection from "@/components/home/HomePageTextSection";
export default function HomePageContent() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HeroHeader />;
    t1 = <LatestDropSection />;
    t2 = <HomePageTextSection />;
    t3 = <div className="tw-h-px tw-w-full tw-bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.08)_15%,rgba(255,255,255,0.08)_85%,transparent_100%)]" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-overflow-x-hidden tw-border-y-0 tw-border-l-0 tw-border-r tw-border-solid tw-border-iron-900">{t0}{t1}{t2}{t3}<div className="tw-pt-10 md:tw-pt-16"><NextMintLeadingSection /><BoostedSection /><ExploreWavesSection /></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}